<template>
  <div class="register-container">
    <!-- 网站logo区域，点击可返回首页 -->
    <a href="/" class="logo-area">
      <div class="logo">
        <img src="@/assets/img/logo.png" alt="Logo" />
      </div>
      <div class="system-name">小微融资机制平台</div>
    </a>
    <!-- 注册表单容器 -->
    <div class="register-box">
      <h2>用户注册</h2>
      <!-- 注册表单 -->
      <el-form
        :model="registerForm"
        :rules="rules"
        ref="registerForm"
        label-width="0px"
      >
        <el-form-item prop="phone">
          <el-input
            v-model="registerForm.phone"
            placeholder="请输入手机号"
            prefix-icon="el-icon-mobile-phone"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="idCard">
          <el-input
            v-model="registerForm.idCard"
            placeholder="请输入身份证号"
            prefix-icon="el-icon-document"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="registerForm.password"
            type="password"
            placeholder="请设置登录密码"
            prefix-icon="el-icon-lock"
            show-password
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="confirmPassword">
          <el-input
            v-model="registerForm.confirmPassword"
            type="password"
            placeholder="请确认登录密码"
            prefix-icon="el-icon-lock"
            show-password
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="verifyCode">
          <div class="verify-code-container">
            <el-input
              v-model="registerForm.verifyCode"
              placeholder="请输入短信验证码"
              prefix-icon="el-icon-message"
            >
            </el-input>
            <el-button
              type="primary"
              :disabled="isSending"
              @click="sendVerifyCode"
            >
              {{ sendBtnText }}
            </el-button>
          </div>
        </el-form-item>

        <el-form-item prop="agreement">
          <el-checkbox v-model="registerForm.agreement">
            我已阅读并同意
            <el-link type="primary" @click="showAgreement('service')"
              >《用户服务协议》</el-link
            >
            和
            <el-link type="primary" @click="showAgreement('privacy')"
              >《隐私政策》</el-link
            >
          </el-checkbox>
        </el-form-item>

        <el-button
          type="primary"
          class="register-button"
          @click="handleRegister"
          :loading="loading"
        >
          立即注册
        </el-button>

        <div class="form-footer">
          <router-link to="/login">已有账号？立即登录</router-link>
        </div>
      </el-form>
    </div>

    <!-- 协议对话框 -->
    <el-dialog
      :modal="false"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <div v-html="dialogContent"></div>
    </el-dialog>
  </div>
</template>

<script>
// 导入token操作工具函数
import { setToken, getToken } from "@/utils/auth";
// 导入API接口函数
import { userRegister, getCaptcha } from "@/api";
export default {
  name: "Register", // 组件名称
  data() {
    // 自定义验证规则
    // 手机号验证函数
    const validatePhone = (rule, value, callback) => {
      if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };

    // 身份证号验证函数
    const validateIdCard = (rule, value, callback) => {
      if (!/^\d{17}[\dXx]$/.test(value)) {
        callback(new Error("请输入正确的18位身份证号码"));
      } else {
        callback();
      }
    };

    // 密码验证函数
    const validatePassword = (rule, value, callback) => {
      if (!/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{8,20}$/.test(value)) {
        callback(new Error("密码必须包含字母和数字，长度8-20位"));
      } else {
        callback();
      }
    };

    // 确认密码验证函数
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.registerForm.password) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };

    return {
      // 注册表单数据
      registerForm: {
        phone: "", // 手机号
        idCard: "412723199547866541", // 身份证号（示例数据）
        password: "", // 密码
        confirmPassword: "", // 确认密码
        verifyCode: "", // 验证码
        agreement: false, // 是否同意协议
      },
      // 表单验证规则
      rules: {
        // 手机号验证规则
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        // 身份证号验证规则
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: validateIdCard, trigger: "blur" },
        ],
        // 密码验证规则
        password: [
          { required: true, message: "请设置登录密码", trigger: "blur" },
          { validator: validatePassword, trigger: "blur" },
        ],
        // 确认密码验证规则
        confirmPassword: [
          { required: true, message: "请确认登录密码", trigger: "blur" },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
        // 验证码验证规则
        verifyCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
          { min: 6, max: 6, message: "验证码长度为6位", trigger: "blur" },
        ],
        // 协议勾选验证规则
        agreement: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请阅读并同意用户协议和隐私政策"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      countdown: 60, // 验证码倒计时秒数
      isSending: false, // 是否正在发送验证码
      sendBtnText: "获取验证码", // 发送按钮文本
      loading: false, // 注册按钮加载状态
      dialogVisible: false, // 协议对话框是否可见
      dialogTitle: "", // 协议对话框标题
      dialogContent: "", // 协议对话框内容
    };
  },
  methods: {
    // 发送验证码方法
    sendVerifyCode() {
      // 先验证手机号是否正确
      this.$refs.registerForm.validateField("phone", (errorMsg) => {
        if (errorMsg) {
          return; // 手机号验证失败，直接返回
        }

        // 设置发送状态和倒计时
        this.isSending = true;
        this.countdown = 60;
        this.sendBtnText = `${this.countdown}秒后重新获取`;

        // 调用发送验证码API
        getCaptcha({
          phone: this.registerForm.phone, // 手机号
          phone_type: 0, // 手机类型，0表示普通用户
        }).then((res) => {
          if (res.status == 200) {
            // 发送成功
            this.$message({
              message: "验证码已发送",
              type: "success",
            });
            // 开始倒计时
            const timer = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown--; // 倒计时减1
                this.sendBtnText = `${this.countdown}秒后重新获取`;
              } else {
                // 倒计时结束
                clearInterval(timer);
                this.isSending = false;
                this.sendBtnText = "获取验证码";
              }
            }, 1000);
          } else {
            // 发送失败处理（当前为空）
          }
        });
      });
    },

    // 处理注册方法
    handleRegister() {
      // 表单验证
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.loading = true; // 设置加载状态

          // 调用注册API
          userRegister({
            phone: this.registerForm.phone, // 手机号
            id_card: this.registerForm.idCard, // 身份证号
            pwd: this.registerForm.password, // 密码
            pwd_again: this.registerForm.confirmPassword, // 确认密码
            code: this.registerForm.verifyCode, // 验证码
          }).then((res) => {
            if (res.status == 200) {
              // 注册成功
              this.loading = false; // 取消加载状态
              this.$message({
                message: "注册成功，请重新登录",
                type: "success",
              });
              this.$router.push("/login"); // 跳转到登录页
            }else{
              this.loading = false
            }
          });
        } else {
          return false; // 表单验证失败
        }
      });
    },

    // 显示协议内容方法
    showAgreement(type) {
      // 根据类型设置不同的协议内容
      if (type === "service") {
        // 服务协议
        this.dialogTitle = "用户服务协议";
        this.dialogContent = "<p>这里是用户服务协议的详细内容...</p>";
      } else if (type === "privacy") {
        // 隐私政策
        this.dialogTitle = "隐私政策";
        this.dialogContent = "<p>这里是隐私政策的详细内容...</p>";
      }
      this.dialogVisible = true; // 显示对话框
    },
  },
};
</script>

<style scoped>
.register-container {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  z-index: 1001;
}

.logo-area {
  position: absolute;
  top: 20px;
  left: 30px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.logo {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.system-name {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.register-container::before {
  content: "";
  position: absolute;
  width: 300px;
  height: 300px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  top: -100px;
  right: -100px;
}

.register-container::after {
  content: "";
  position: absolute;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  bottom: -50px;
  left: -50px;
}

.register-box {
  width: 100%;
  max-width: 480px;
  padding: 40px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  position: relative;
  animation: fadeIn 0.8s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

h2 {
  text-align: center;
  color: #2c3e50;
  margin-bottom: 25px;
}

.verify-code-container {
  display: flex;
}

.verify-code-container .el-input {
  margin-right: 10px;
}

.verify-code-container .el-button {
  width: 120px;
  font-size: 12px;
}

.register-button {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  margin-top: 10px;
}

.form-footer {
  text-align: center;
  margin-top: 20px;
}

.form-footer a {
  color: #409eff;
  text-decoration: none;
}

.form-footer a:hover {
  text-decoration: underline;
}
</style>